import ChatButton from '../components/ChatButton';
import HelpBand from '../components/HelpBand';
import PageHero from '../components/PageHero';
import { topics } from '../data';

export default function HelpTopics() {
  return (
    <>
      <PageHero title="Help Topics">
        Practical first steps for the most common Family Tree Maker problems. Always make a backup before you change
        anything.
      </PageHero>

      <section className="section">
        <div className="wrap topic-grid">
          {topics.map((topic) => (
            <article key={topic.slug} id={topic.slug} className="topic-card">
              <h2>{topic.title}</h2>
              <p>{topic.summary}</p>
              <ul className="tick-list">
                {topic.tips.map((tip) => (
                  <li key={tip}>{tip}</li>
                ))}
              </ul>
              <ChatButton variant="outline" size="sm">
                Get help with this
              </ChatButton>
            </article>
          ))}
        </div>
      </section>

      <HelpBand />
    </>
  );
}
